import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
    fetchEmployee,
    fetchEmployeeDependent,
    fetchDeleteEmployeeDependent
} from '../../actions/EmployeeActions';
import { ContentCard } from '../Cards';
import EmployeeDependentDeleteSchema from './EmployeeDependentDeleteSchema';
import EmployeeDependentDeleteUISchema from './EmployeeDependentDeleteUISchema';
import { Form } from '../../utils/FormTemplates';
import { userService } from '../../utils/UserService';
import { stepNumberHelper } from '../../utils/StepNumberHelper';
import { fetchUpdatePackageProgress } from '../../actions/EnrollmentActions';

class EmployeeDependentDelete extends Component {
    state = {
        employeeId: null,
        groupId: null
    };

    componentDidMount() {
        userService
            .currentPersonId()
            .then(personId => {
                if (this.props.packageId) {
                    this.props.fetchEmployee(personId, this.props.packageId).then(employee => {
                        if(employee && employee.personId === parseInt(personId, 10)) {
                            this.setState({
                                employeeId: employee.personId,
                                groupId: employee.groupId
                            });
                            this.props.fetchEmployeeDependent(this.props.match.params.dependentid, employee.personId, employee.groupid);
                        }
                    });
                }
            });
    }

    onCancel = e => {
        this.props.history.goBack();
    };

    onDeleteEmployeeDependent(e) {
        e.formData.enrollmentPackageId = this.props.packageId;
        this.props.deleteEmployeeDependent(this.props.match.params.dependentid, e.formData, this.state.employeeId, this.state.groupId)
            .then(() => {
                const activePackage = this.props.activePackage;
                const currentStepNumber = stepNumberHelper.stepNumberForNamedStep(activePackage, 'Dependents');
                this.props.fetchUpdatePackageProgress(this.props.packageId, currentStepNumber, true)
                    .then(() => {
                        this.props.history.push(`/packages/${this.props.packageId}/dependents`);
                    });
        });
    }

    render() {
        const { item: dependent, loading, error } = this.props.activeEmployeeDependent;
        const dependentPersonId = parseInt(this.props.match.params.dependentid, 10);

        let schema = EmployeeDependentDeleteSchema;
        schema.title = dependent
            && dependent.nameFirst
            && dependent.nameLast
            ? 'Remove ' + dependent.nameFirst + ' ' + dependent.nameLast : 'Remove Dependent';

        let uiSchema = EmployeeDependentDeleteUISchema;

        var reasonIds = [];
        var reasonNames = [];

        if (dependent !== null) {
            if (dependent.relationshipTypeId === 1 || dependent.relationshipTypeId === 3) {
                reasonIds = [1, 2, 3, 4, 5];
                reasonNames = ['Divorce/Legal Separation', 'Term Domestic Partnership', 'Dependent No Longer Eligible', 'Death', 'Other'];
            }
            else {
                reasonIds = [3, 4, 5];
                reasonNames = ['Dependent No Longer Eligible', 'Death', 'Other'];
            }
        }

        schema.properties.relationshipTermReasonId.enum = reasonIds;
        schema.properties.relationshipTermReasonId.enumNames = reasonNames;

        return (
            dependent && dependent.personId === dependentPersonId ?
                <ContentCard loading={loading} error={error}>
                    <div>
                        Please ONLY delete dependents if the relationship status has changed or if they are no longer eligible for coverage.  Eligible dependents can be terminated from coverage on specific policy screens.
                        <br />
                        <br />
                    </div>
                    <Form schema={schema}
                        uiSchema={uiSchema}
                        formData={dependent}
                        onSubmit={e => this.onDeleteEmployeeDependent(e)}
                    >
                        <div className="float-right">
                            <button type="button" className="btn btn-default mr-2" onClick={e => this.onCancel(e)}>Cancel</button>
                            <button type="submit" className="btn btn-primary">Submit</button>
                        </div>
                    </Form>
                </ContentCard>
                : <div />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeEmployeeDependent: state.employeeDependents.activeEmployeeDependent,
        activePackage: state.packages.activePackage.data
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        deleteEmployeeDependent: (dependentId, dependentDelete, employeeId, groupId) => {
            return dispatch(fetchDeleteEmployeeDependent(dependentId, dependentDelete, employeeId, groupId));
        },
        fetchEmployee: (employeeId, packageId) => {
            return dispatch(fetchEmployee(employeeId, packageId));
        },
        fetchEmployeeDependent: (dependentId, employeeId, groupId) => {
            return dispatch(fetchEmployeeDependent(dependentId, employeeId, groupId));
        },
        fetchUpdatePackageProgress: (packageId, stepNumber, updateSteps) => {
            return dispatch(fetchUpdatePackageProgress(packageId, stepNumber, updateSteps));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EmployeeDependentDelete));